export default __webpack_public_path__ + "static/media/HomeLife.2eaf63ba.jpg";